

/*******************************************************************************
 * Initial state
 */
const initialState = {
    successMessages: [],
    done: false
};


/*******************************************************************************
 * Action types
 */
export const SUCCESS_ADD = 'SUCCESS_ADD';
export const SUCCESS_DISMISS = 'SUCCESS_DISMISS';


/*******************************************************************************
 * Reducer
 */
export default function successData( state = initialState, action ) {
    switch ( action.type ) {
        case SUCCESS_ADD:
            return {
                ...state,
                successMessages: [ ...state.successMessages, Object.assign( { message: action.success, successType: action.successType } ) ],
                done: action.done
            };

        case SUCCESS_DISMISS:
            return {
                ...state,
                successMessages: [],
                done: false
            };
        default:
            return state;
    }
}


/*******************************************************************************
 * Action creators
 */

export function addSuccessString( flag, success, successType ) {
    return ( dispatch ) => {
        dispatch( {
            type: SUCCESS_ADD,
            done: flag,
            success,
            successType
        } );
    };
}

export function dismissSuccess ( flag ) {
    return {
        type: SUCCESS_DISMISS
    };
}